import { DecisionState } from './enums/DecisionState';

export type SeatAreaInfo = {
    PlayerName: string;
    PlayerID: number;
    SeatBet: number;
    BetBehind: number;
    IsBetBehindSplit: boolean;
    PairBet: number;
    WinningCount: number;
    DecisionState: DecisionState;
    PreDecision: number;
    CanLeave: boolean;
    IsSplit: boolean;
    IsInsurance: boolean;
    IsSurrender: boolean;
    IsMe: boolean;
};

export type BetSeats = {
    HostId: number;
    DecisionStateStep: string;
    inSeatLastRound: boolean;
    Seat1: SeatAreaInfo;
    Seat2: SeatAreaInfo;
    Seat3: SeatAreaInfo;
    Seat4: SeatAreaInfo;
    Seat5: SeatAreaInfo;
    Seat6: SeatAreaInfo;
    Seat7: SeatAreaInfo;
};

export type BetSeatIndex =
    | 'Seat1'
    | 'Seat2'
    | 'Seat3'
    | 'Seat4'
    | 'Seat5'
    | 'Seat6'
    | 'Seat7';

export type BetSeatNum = 1 | 2 | 3 | 4 | 5 | 6 | 7;
export const getBetSeatNum = (seat: BetSeatIndex | undefined) => {
    const seatList = [
        undefined,
        'Seat1',
        'Seat2',
        'Seat3',
        'Seat4',
        'Seat5',
        'Seat6',
        'Seat7',
    ];
    return seatList.indexOf(seat);
};

export const getEmptyBetSeatsInfo = () => ({
    PlayerName: '',
    PlayerID: 0,
    SeatBet: 0,
    BetBehind: 0,
    IsBetBehindSplit: false,
    PairBet: 0,
    WinningCount: 0,
    DecisionState: 0,
    PreDecision: 0,
    CanLeave: false,
    IsSplit: false,
    IsInsurance: false,
    IsSurrender: false,
    IsMe: false,
});

export const getNewBetSeats = (hostId: number): BetSeats => ({
    HostId: hostId,
    DecisionStateStep: '',
    inSeatLastRound: false,
    Seat1: getEmptyBetSeatsInfo(),
    Seat2: getEmptyBetSeatsInfo(),
    Seat3: getEmptyBetSeatsInfo(),
    Seat4: getEmptyBetSeatsInfo(),
    Seat5: getEmptyBetSeatsInfo(),
    Seat6: getEmptyBetSeatsInfo(),
    Seat7: getEmptyBetSeatsInfo(),
});
